function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.01 21 23 12 2.01 3 2 10l15 2-15 2Z",
    style: {
      fill: "#0a1343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0Z",
    style: {
      fill: "none"
    }
  }));
};
export default SvgSend;